import React, { useEffect } from 'react';
import { Pane, Rectangle, useMap } from 'react-leaflet';

const CoveragePane = (props) => {
    const { fillOpacity } = props;
    const map = useMap();

    // マップが移動したら覆う範囲を更新
    useEffect(() => {
        const updateBounds = () => {
            const bounds = [[90, 180], [-90, -180]];
            rectangleRef.current.setBounds(bounds);
        };

        map.on('moveend', updateBounds);

        // コンポーネントがアンマウントされたらイベントリスナーを解除
        return () => {
            map.off('moveend', updateBounds);
        };
    }, [map]);

    // 覆う範囲を表すRectangleコンポーネントのリファレンス
    const rectangleRef = React.useRef();

    return (
        <Pane name="gray-cover">
            <Rectangle
                ref={rectangleRef}
                bounds={map.getBounds()}
                color="#090909"
                pathOptions={{ fillOpacity: fillOpacity}}
                weight={0} />
        </Pane>
    );
};

export default CoveragePane;
